import { orderBy } from 'lodash';

import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

export const POST_THRESHOLD_DAYS = 5;
export const COMMENT_THRESHOLD_DAYS = 2;

const POST_THRESHOLD_SEC = POST_THRESHOLD_DAYS * 24 * 60 * 60;
const COMMENT_THRESHOLD_SEC = COMMENT_THRESHOLD_DAYS * 24 * 60 * 60;

const hasCommentedLabel = ({ postDate, commentDate }) =>
  commentDate &&
  dayjs().diff(postDate, 'seconds') > POST_THRESHOLD_SEC &&
  dayjs().diff(commentDate, 'seconds') < COMMENT_THRESHOLD_SEC;

/**
 * Returns info about latest comment if post meets certain requirements,
 * otherwise return null.
 *
 * @param {object} params
 * @param {object} params.item Live Feed post object
 * @returns {object|null}
 */
export const itemCommentedLabelParams = ({ item }) => {
  const { pinned, comments, publishedAt, lastContributors } = item;

  let latestComment;

  if (comments?.length > 0) {
    const orderedComments = orderBy(comments, ['created_at'], 'desc');

    [latestComment] = orderedComments;
  } else if (lastContributors?.length > 0) {
    const lastContributor = lastContributors[0];

    latestComment = {
      user: lastContributor,
      created_at: lastContributor?.comment_created_at,
    };
  }

  const hasLabel =
    !pinned &&
    latestComment &&
    hasCommentedLabel({
      postDate: publishedAt,
      commentDate: latestComment.created_at,
    });

  return hasLabel ? { comment: latestComment } : null;
};
